import { Injectable } from "@angular/core";
import { ApiService } from "../../core/services/api.service";
import { Observable } from "rxjs/Observable";
import {
  ProfileDTO,
  SubscriptionStateConditionDTO,
} from "../../shared/DTO/ProfileDTO";
import { Routine } from "./routines.model";
import { HttpResponse, HttpHeaders, HttpParams } from "@angular/common/http";
import { catchError } from "rxjs/operators";

@Injectable()
export class RoutinesService {
  constructor(private apiService: ApiService) {}

  getRoutines(houseId: string): Observable<any> {
    return this.apiService.get(`/routines/house/${houseId}/routine`);
  }

  activateRoutine(houseId: string, routineId: string): Observable<any> {
    return this.apiService.post<any>(
      `/routines/house/${houseId}/routine/${routineId}`,
      null
    );
  }

  getSwitcDevices(houseId: string, routineId: string): Observable<any> {
    return this.apiService.post<any>(
      `/routines/house/${houseId}/routine/${routineId}`,
      null
    );
  }

  createRoutine(houseId: string, routine: Routine): Observable<any> {
    return this.apiService.post<any>(
      `/routines/house/${houseId}/routine`,
      routine
    );
  }

  editRoutine(houseId: string, routine: Routine, body): Observable<any> {
    return this.apiService.put<any>(
      `/routines/house/${houseId}/routine/${routine.routineId}`,
      body
    );
  }

  deleteRoutine(houseId: string, routine: Routine): Observable<any> {
    return this.apiService.delete<any>(
      `/routines/house/${houseId}/routine/${routine.routineId}`,
      null
    );
  }

  // createRoutine(profileDTO: ProfileDTO): Observable<any> {
  //   return this.apiService.post<ProfileDTO>(`/HA/{{sessionId}}/Profiles`, profileDTO);
  // }

  // getRoutineDevice(profileDTO: ProfileDTO): Observable<any> {
  //   return this.apiService.get<ProfileDTO>(`/HA/{{sessionId}}/Profiles(${profileDTO.PKID})/Conditions`);
  // }

  // createRoutineDevice(profilePkid: string, subscriptionStateConditionDTO: SubscriptionStateConditionDTO): Observable<any> {
  //   return this.apiService.post<ProfileDTO>(`/HA/{{sessionId}}/Profiles(${profilePkid})/Conditions`, subscriptionStateConditionDTO);
  // }

  // updateRoutineName(profileDTO: ProfileDTO) {
  //   const body = {
  //     Name: profileDTO.Name
  //    };
  //   return this.apiService.patch(`/HA/{{sessionId}}/Profiles(${profileDTO.PKID})`, body);
  // }

  // updateRoutineDeviceRelayState(profilePkid: string, moduleId: string, value: string) {
  //   const body = {
  //     Value: value
  //    };
  //   /* tslint:disable */
  //   return this.apiService.patch(`/HA/{{sessionId}}/Profiles(${profilePkid})/Conditions(SubscriptionStateId=${profilePkid},ModuleId=${moduleId},StateVar='relayState')`, body);
  // }

  // deleteRoutineDevice(profilePkid: string, moduleId){
  //   /* tslint:disable */
  //   return this.apiService.delete(`/HA/{{sessionId}}/Profiles(${profilePkid})/Conditions(SubscriptionStateId=${profilePkid},ModuleId=${moduleId},StateVar='relayState')`);
  // }

  // deleteRoutine(pkid: string): Observable<any> {
  //   return this.apiService.delete(`/HA/{{sessionId}}/Profiles(${pkid})`);
  // }

  // activateRoutine(pkid: string): Observable<any> {
  //   return this.apiService.post(`/HA/{{sessionId}}/Profiles(${pkid})/Run`, null);
  // }
}



// WEBPACK FOOTER //
// ./src/app/entities/routines/routines.service.ts